import { IconFolder, IconFolderOpen } from '@tabler/icons-react';
import { useFela } from 'react-fela';
import { generatePath } from 'react-router-dom-v5-compat';

import { config } from '@/config/config';
import type { Vault } from '@/modules/api/codegen';
import { Link } from '@/modules/ui';

import * as felaRules from './VaultLink.rules';

export interface VaultLinkProps {
    vault: Vault;
}

export const VaultLink = ({ vault }: VaultLinkProps) => {
    const { css } = useFela();

    return (
        <Link type='router' to={generatePath(config.routes.vault, { vaultId: vault.id })} customStyle={felaRules.item}>
            {({ isActive }) => {
                const FolderIcon = isActive ? IconFolderOpen : IconFolder;

                return (
                    <>
                        <span className={css(felaRules.label)}>
                            <FolderIcon size={16} className={css(felaRules.icon)} />
                            <span className={css(felaRules.name)}>{vault.name}</span>
                        </span>
                        {vault.secretsCount === undefined ? null : <span className={css(felaRules.count)}>{vault.secretsCount}</span>}
                    </>
                );
            }}
        </Link>
    );
};
